import { Component, OnInit } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { interval } from 'rxjs';
import { startWith, switchMap } from "rxjs/operators";
import { S13ListService } from './s13-list.service';

@Component({
  selector: 'app-s13-list',
  templateUrl: './s13-list.component.html',
  styleUrls: ['./s13-list.component.scss']
})
export class S13ListComponent implements OnInit {
  arrCalls: string[];
  arrStudents: string[];
  myVar: string;
  hours: string;
  minutes: string;
  actualTime: string;
  public totemPGeral = 3;

  private setCurrentTime() {
    const time = new Date(Date.now());
    this.hours = this.leftPadZero(time.getHours());
    this.minutes = this.leftPadZero(time.getMinutes());

    this.actualTime = ((parseInt(this.hours)* 60 + parseInt(this.minutes))*60).toString();
  }

  private leftPadZero(value: number) {
    return value < 10 ? `0${value}` : value.toString();
  }

  public validateCallPessoaFiltro(call, type) {
    let descricao = '';
    switch (type) {
      case 'filtroNome':
        if(call.pessoa.filtroNome && call.pessoa.filtroNome.descricao)
          descricao =  call.pessoa.filtroNome.descricao;
        break;
      case 'filtroSerie':
        if(call.pessoa.filtroSerie && call.pessoa.filtroSerie.descricao)
          descricao = call.pessoa.filtroSerie.descricao;
        break;
      case 'filtroTurma':
        if(call.pessoa.filtroTurma && call.pessoa.filtroTurma.descricao)
          descricao = call.pessoa.filtroTurma.descricao;
        break;    
      case 'filtroMatricula':
        if(call.pessoa.filtroMatricula && call.pessoa.filtroMatricula.descricao)
          descricao = call.pessoa.filtroMatricula.descricao;
        break;    
      default:
        descricao = '';
        break;
    }
    return descricao;
  }

  getImages(chamada: string) {
    return chamada == "Rechamada" 
    ? "../../../assets/images/tabletrec.png"  
    : chamada == "Chamada"
      ? "../../../assets/images/tablet.png"
      :"../../../assets/images/mic.png";
  }
  
  constructor(private listService: S13ListService) { }

  ngOnInit() {
    interval(2000)
      .pipe(
        startWith(0),
        switchMap(() => this.listService.getList())
      )
      .subscribe(data => {

        this.setCurrentTime();
        if (true) {
          
        this.arrCalls = data as string[];

        this.listService.getStudentAccess().subscribe(data => {
          this.arrStudents = data as string[];
          if(typeof this.arrStudents != "undefined" && this.arrStudents != null && this.arrStudents.length != null
          && this.arrStudents.length > 0){
          for(let i = 0; i < this.arrCalls.length; i++){
            let respAccessId: any = JSON.parse(JSON.stringify(this.arrCalls[i])).id;
            let respIdent: any = this.validateCallPessoaFiltro(JSON.parse(JSON.stringify(this.arrCalls[i])),'filtroMatricula');
            for(let j = 0; j < this.arrStudents.length; j++){
              let acesso: any = JSON.parse(JSON.stringify(this.arrStudents[j]));
              let studentIdent: any = acesso.pessoa.identificador;
              if ((respIdent.toString() == studentIdent.toString()) && acesso.tipoAcesso == 2) {
                  this.listService.updateRespAccess(respAccessId);
              }
            }
          }
        }
        });
        
        for (let i = 0; i < this.arrCalls.length; i++) {
          this.myVar;
          if (JSON.parse(JSON.stringify(this.arrCalls[i])).pessoa.filtroBloqueio.descricao == 'Sim') {
            this.myVar = 'fa-lock';
          } else {
            this.myVar = 'fa-lock-open';
          }
          
          let hour: any = parseInt(String(JSON.parse(JSON.stringify(this.arrCalls[i])).hora / 3600))
          let min: any = ((((data[i].hora / 3600) - Math.floor((data[i].hora) / 3600)).toFixed(8)));
          let min_conv: any = (min * 60).toFixed(0);
          data[i].hora = `${hour}` + ':' + min_conv;
        };
      }
      },
        (err: HttpErrorResponse) => {
        }
      );
  }
}
